// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"f3e49dd7","498":"5b303c04","703":"827ec57b"}[chunkId] + ".chunk.js";
};